import React from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
} from "@refinedev/antd";
import { Table, Space, Form } from "antd";
import type { BaseRecord } from "@refinedev/core";

export const CategoryList: React.FC = () => {
  const { tableProps, searchFormProps } = useTable();

  return (
    <>
      {/* 隐藏的 Form，用于绑定 useTable 内部的 form 实例，避免警告 */}
      <Form form={searchFormProps?.form} style={{ display: "none" }} />

      <List
        title="分类管理"
        headerButtons={({ defaultButtons }) => (
          <Space>
            {defaultButtons}
          </Space>
        )}
      >
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="name" title="名称" />
        <Table.Column dataIndex="slug" title="Slug" />
        <Table.Column
          dataIndex="description"
          title="描述"
          ellipsis={{ showTitle: true }}
        />
        <Table.Column
          title="操作"
          dataIndex="actions"
          render={(_, record: BaseRecord) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
      </List>
    </>
  );
};
